import { NextResponse } from "next/server"

const DEFAULT_PLACEHOLDER = "/static/img/not-found.svg"
const MAX_IMAGE_SIZE_BYTES = 5_000_000 // 5MB

const ALLOWED_HOSTS = [
  "localhost",
  "secure.gravatar.com",
  "dev-marketplace.triibo.com.br",
]

/**
 * Redireciona para o placeholder local
 */
function placeholderRedirect(req: Request): NextResponse {
  const placeholderUrl = new URL(DEFAULT_PLACEHOLDER, req.url)
  return NextResponse.redirect(placeholderUrl.toString(), 302)
}

/**
 * Validação de segurança da URL
 */
function isAllowedImageUrl(src: string): boolean {
  try {
    const url = new URL(src)

    if (!["http:", "https:"].includes(url.protocol)) {
      return false
    }

    return ALLOWED_HOSTS.includes(url.hostname)
  } catch {
    return false
  }
}

export async function GET(req: Request): Promise<Response> {
  const { searchParams } = new URL(req.url)
  const src = searchParams.get("src")

  if (!(src && isAllowedImageUrl(src))) {
    return placeholderRedirect(req)
  }

  try {
    /**
     * HEAD → valida status, tipo e tamanho
     */
    const head = await fetch(src, { method: "HEAD" })

    if (!head.ok) {
      return placeholderRedirect(req)
    }

    const contentType = head.headers.get("content-type") ?? ""
    if (!contentType.startsWith("image/")) {
      return placeholderRedirect(req)
    }

    const contentLength = head.headers.get("content-length")
    if (contentLength && Number(contentLength) > MAX_IMAGE_SIZE_BYTES) {
      return placeholderRedirect(req)
    }

    /**
     * GET final
     */
    const upstream = await fetch(src)
    if (!upstream.ok) {
      return placeholderRedirect(req)
    }

    const buffer = await upstream.arrayBuffer()

    return new NextResponse(buffer, {
      status: 200,
      headers: {
        "content-type": contentType,
        "cache-control": "public, max-age=86400, stale-while-revalidate=604800",
        "x-content-type-options": "nosniff",
      },
    })
  } catch {
    return placeholderRedirect(req)
  }
}
